import { Box } from '@mui/material'

import metacrocLogo from '@/assets/metacroc-mark.png'
import { useAppContext } from '@/hooks'
import { SystemSelection } from '@/pages/User/pages/Home/components/TreePanel/components/SystemSelection'

import { NavBarTabs } from './NavBarTabs'
import { Search } from './Search/Search'
import { NavBrandIcon, NavContainer } from './styles'
import { UserMenu } from './UserMenu'

export const Navbar = () => {
	const { t } = useAppContext()

	return (
		<NavContainer data-testid="navbar">
			<NavBrandIcon
				src={metacrocLogo}
				alt={t('APPLICATION_LOGO_ALT')}
				data-testid="navbar-logo"
			/>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					ml: 1,
					mr: 1,
					flexShrink: 0,
				}}
			>
				<SystemSelection variant="navbar" />
			</Box>
			<NavBarTabs />
			<Search />
			<UserMenu />
		</NavContainer>
	)
}
